import { ChangeEmployeeModal } from './ChangeEmployeeModal';
import { Comment } from './Comment';
import { CommentContainer } from './CommentContainer';
import { FinishTaskModal } from './FinishTaskModal';
import { FormItem } from './FormItem';
import { HistoryModal } from './HistoryModal';
import { HistoryModalContent } from './HistoryModalContent';
import { TableHeader } from './TableHeader';
import { TableTextComponent } from './TableTextComponent';
import { TaskListPageHeader } from './TaskListPageHeader';
import { TaskListRegistry } from './TaskListRegistry';
import { TaskTypeOptionLabel } from './TaskTypeOptionLabel';

export {
  TaskListRegistry,
  TaskListPageHeader,
  TableTextComponent,
  FormItem,
  HistoryModal,
  TableHeader,
  FinishTaskModal,
  ChangeEmployeeModal,
  Comment,
  HistoryModalContent,
  CommentContainer,
  TaskTypeOptionLabel,
};
